/* eslint-disable prefer-const */
import axios from 'axios';
// eslint-disable-next-line
import { decodeRSA } from '@/mixins/function';
import {
  getRumDuration,
  startRumTiming,
  trackApiRequest,
} from '@/observability/datadogRum';
import { getUrl } from './apiIndex';

const API_URL = process.env.VUE_APP_BASE_API_URL || 'https://geosort.falabella.com/api/';
// const API_URL = process.env.API_URL || 'http://localhost:';

export default axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${sessionStorage.token}`,
  },
});

export const version = 'v1';
export const wsUrl = 'ws://geosort.falabella.com/api/tracing-service';

let header = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  Authorization: `Bearer ${sessionStorage.token}`,
};

let reportHeader = {
  Accept: '*/*',
  'Accept-Encoding': 'gzip, deflate',
  Authorization: `Bearer ${sessionStorage.token}`,
};

// eslint-disable-next-line
export const updateToken = function () {
  header = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Bearer ${sessionStorage.token}`,
    email: sessionStorage.user_email || '',
  };
  reportHeader = {
    Accept: '*/*',
    'Accept-Encoding': 'gzip, deflate',
    Authorization: `Bearer ${sessionStorage.token}`,
  };
};

export const apiRequest = function request({
  module, service, pathparam: pathparams, params = {}, country,
}) {
  const data = getUrl(module, service, pathparams);
  header['X-Country'] = country === undefined ? decodeRSA(sessionStorage.country) : country;
  header.email = sessionStorage.user_email || '';
  const metadata = {
    module,
    service,
    source: 'apiRequest',
  };
  if (data.route !== '') {
    switch (data.method) {
      case 'patch':
        return axios.patch(data.route, params, {
          headers: header,
          metadata,
        });
      case 'put':
        return axios.put(data.route, params, {
          headers: header,
          metadata,
        });
      case 'post':
        return axios.post(data.route, params, {
          headers: header,
          metadata,
        });
      case 'get':
        return axios.get(data.route, {
          headers: header,
          metadata,
          params,
        });
      case 'delete':
        return axios.delete(data.route, {
          headers: header,
          metadata,
          params,
        });
      default:
        return null;
    }
  }
  return null;
};

export const getReport = ({
  module, service, pathparam: pathparams, country,
}) => {
  const data = getUrl(module, service, pathparams);
  const startedAt = startRumTiming();
  reportHeader['X-Country'] = country === undefined ? decodeRSA(sessionStorage.country) : country;
  return fetch(data.route, {
    headers: reportHeader,
    responseType: 'blob',
  }).then((response) => {
    trackApiRequest({
      module,
      service,
      method: 'GET',
      url: data.route,
      status: response.status,
      durationMs: getRumDuration(startedAt),
      source: 'fetch',
      success: response.ok,
    });
    return response;
  }).catch((error) => {
    trackApiRequest({
      module,
      service,
      method: 'GET',
      url: data.route,
      status: 0,
      durationMs: getRumDuration(startedAt),
      source: 'fetch',
      success: false,
    });
    throw error;
  });
};


export const getReport2 = ({
  module, service,
  pathparams,
  country,
}) => {
  const data = getUrl(module, service, pathparams);
  const startedAt = startRumTiming();
  reportHeader['X-Country'] = country === undefined ? decodeRSA(sessionStorage.country) : country;
  const paramsUrl = Object.keys(pathparams).map((key) => {
    const uri = `${encodeURIComponent(key)}=${encodeURIComponent(pathparams[key])}`;
    return uri;
  }).join('&');
  const requestUrl = `${data.route}?${paramsUrl}`;
  const miInit = {
    method: 'GET',
    headers: reportHeader,
    mode: 'cors',
    cache: 'default',
  };
  return fetch(requestUrl, miInit, {
    headers: reportHeader,
  }).then((response) => {
    trackApiRequest({
      module,
      service,
      method: 'GET',
      url: requestUrl,
      status: response.status,
      durationMs: getRumDuration(startedAt),
      source: 'fetch',
      success: response.ok,
    });
    return response;
  }).catch((error) => {
    trackApiRequest({
      module,
      service,
      method: 'GET',
      url: requestUrl,
      status: 0,
      durationMs: getRumDuration(startedAt),
      source: 'fetch',
      success: false,
    });
    throw error;
  });
};

export const edit = function request({ service, path, params = {} }) {
  const requestUrl = `${API_URL + service}/${version}/${path}`;
  return axios.put(requestUrl, params, {
    headers: header,
    metadata: {
      service: path,
      module: service.replace(/-service$/, '').replace(/-/g, '_'),
      source: 'edit',
    },
  });
};
